import Notify from 'quasar/src/plugins/Notify.js';

Notify.setDefaults({
  position: 'top',
  timeout: 10000,
  progress: true,
  textColor: 'white',
  actions: [{ label: 'Close', color: 'white' }]
})
